/**
 * The design system's class-name joiner, lifted verbatim from the top of
 * resources/Dental supply storefront design system/tw-components.jsx.
 *
 * Kept as its own module because upstream is one big file and every ported
 * component needs it. Same behaviour as `classnames` for the string case, but
 * matching upstream exactly keeps the ported components diffable.
 */
export const cx = (...a) => a.filter(Boolean).join(" ");
